export const CALENDAR_GET_CATEGORY_SETTINGS_START = 'CALENDAR_GET_CATEGORY_SETTINGS_START';
export const CALENDAR_GET_CATEGORY_SETTINGS_SUCCESS = 'CALENDAR_GET_CATEGORY_SETTINGS_SUCCESS';
export const CALENDAR_GET_CATEGORY_SETTINGS_FAIL = 'CALENDAR_GET_CATEGORY_SETTINGS_FAIL';

export const CALENDAR_GET_CATEGORIES_START = 'CALENDAR_GET_CATEGORIES_START';
export const CALENDAR_GET_CATEGORIES_SUCCESS = 'CALENDAR_GET_CATEGORIES_SUCCESS';
export const CALENDAR_GET_CATEGORIES_FAIL = 'CALENDAR_GET_CATEGORIES_FAIL';

export const CALENDAR_GET_EVENTS_START = 'CALENDAR_GET_EVENTS_START';
export const CALENDAR_GET_EVENTS_SUCCESS = 'CALENDAR_GET_EVENTS_SUCCESS';
export const CALENDAR_GET_EVENTS_FAIL = 'CALENDAR_GET_EVENTS_FAIL';

export const CALENDAR_SAVE_EVENT_START = 'CALENDAR_SAVE_EVENT_START';
export const CALENDAR_SAVE_EVENT_SUCCESS = 'CALENDAR_SAVE_EVENT_SUCCESS';
export const CALENDAR_SAVE_EVENT_FAIL = 'CALENDAR_SAVE_EVENT_FAIL';

export const CALENDAR_DELETE_EVENT_START = 'CALENDAR_DELETE_EVENT_START';
export const CALENDAR_DELETE_EVENT_SUCCESS = 'CALENDAR_DELETE_EVENT_SUCCESS';
export const CALENDAR_DELETE_EVENT_FAIL = 'CALENDAR_DELETE_EVENT_FAIL';

export const CALENDAR_SAVE_CATEGORY_START = 'CALENDAR_SAVE_CATEGORY_START';
export const CALENDAR_SAVE_CATEGORY_SUCCESS = 'CALENDAR_SAVE_CATEGORY_SUCCESS';
export const CALENDAR_SAVE_CATEGORY_FAIL = 'CALENDAR_SAVE_CATEGORY_FAIL';

export const CALENDAR_DELETE_CATEGORY_START = 'CALENDAR_DELETE_CATEGORY_START';
export const CALENDAR_DELETE_CATEGORY_SUCCESS = 'CALENDAR_DELETE_CATEGORY_SUCCESS';
export const CALENDAR_DELETE_CATEGORY_FAIL = 'CALENDAR_DELETE_CATEGORY_FAIL';

export const CALENDAR_SAVE_CATEGORY_SETTING_START = 'CALENDAR_SAVE_CATEGORY_SETTING_START';
export const CALENDAR_SAVE_CATEGORY_SETTING_SUCCESS = 'CALENDAR_SAVE_CATEGORY_SETTING_SUCCESS';
export const CALENDAR_SAVE_CATEGORY_SETTING_FAIL = 'CALENDAR_SAVE_CATEGORY_SETTING_FAIL';

export const CALENDAR_DELETE_CATEGORY_SETTING_START = 'CALENDAR_DELETE_CATEGORY_SETTING_START';
export const CALENDAR_DELETE_CATEGORY_SETTING_SUCCESS = 'CALENDAR_DELETE_CATEGORY_SETTING_SUCCESS';
export const CALENDAR_DELETE_CATEGORY_SETTING_FAIL = 'CALENDAR_DELETE_CATEGORY_SETTING_FAIL';
